import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsectaServiceBase } from './insecta.base.service';
import {
  IOrderItemInstance,
  IOrderItemInstanceAddVendorDelayInfoRequest,
  IOrderItemInstanceAddVendorDeliveryDateRequest,
  IOrderItemInstanceAddVendorNameAndSitePermitRequest,
  IOrderItemInstanceUpdateDeliveryLocationRequest,
  IOrderItemInstanceUpdateShippingRequest,
  IOrderItemInstanceUpdateStatusRequest
} from './insecta.models';

@Injectable({
  providedIn: 'root'
})
export class OrderItemInstanceService extends InsectaServiceBase {
  public postOrderItemInstance(orderId: string, itemId: string, addRequest: IOrderItemInstance): Observable<any> {
    return this.post<any>(`/orders/${orderId}/items/${itemId}/instances`, 'v1', addRequest);
  }

  public getOrderItemInstance(orderId: string, itemId: string, id: string): Observable<IOrderItemInstance> {
    return this.get<IOrderItemInstance>(`/orders/${orderId}/items/${itemId}/instances/${id}`, 'v1');
  }

  public addSetupDateOrderItemInstance(orderId: string, itemId: string, id: string, updateRequest: any): Observable<any> {
    return this.put<IOrderItemInstance>(`/orders/${orderId}/items/${itemId}/instances/${id}/addSetupDate`, `v1`, updateRequest);
  }

  public updateContainerQuantity(orderId: string, id: string, updateRequest: any): Observable<any> {
    return this.put<IOrderItemInstance>(`/orders/${orderId}/instances/${id}/updateContainerQuantity`, `v1`, updateRequest);
  }

  public addVendorNameAndSitePermitOrderItemInstance(request: IOrderItemInstanceAddVendorNameAndSitePermitRequest): Observable<void> {
    return this.put(`/instances/addVendorNameAndSitePermit`, `v1`, request);
  }

  public addVendorDelayInfoOrderItemInstance(request: IOrderItemInstanceAddVendorDelayInfoRequest): Observable<void> {
    return this.put(`/instances/addVendorDelayInfo`, `v1`, request);
  }

  public addVendorDeliveryDateOrderItemInstance(request: IOrderItemInstanceAddVendorDeliveryDateRequest): Observable<void> {
    return this.put(`/instances/addVendorDeliveryDate`, `v1`, request);
  }

  public updateOrderItemInstance(
    orderId: string,
    itemId: string,
    id: string,
    updateRequest: any,
    option: string,
    status?: string,
    rescheduleInstanceDates?: string[]
  ): Observable<any> {
    return this.put<IOrderItemInstance>(
      `/orders/${orderId}/items/${itemId}/instances/${id}?option=${option}&status=${status}&rescheduleInstanceDates=${rescheduleInstanceDates}`,
      `v1`,
      updateRequest
    );
  }

  public deleteOrderItemInstance(orderId: string, itemId: string, id: string): Observable<any> {
    return this.delete(`/orders/${orderId}/items/${itemId}/instances/${id}`, 'v1');
  }

  public updateOrderItemInstanceDeliveryLocation(instances: string[], location: string): Observable<void> {
    const request = <IOrderItemInstanceUpdateDeliveryLocationRequest>{
      instances: instances,
      deliveryLocation: location
    };
    return this.put(`/instances/delivery`, `v1`, request);
  }

  public updateOrderItemInstanceShipping(request: IOrderItemInstanceUpdateShippingRequest): Observable<void> {
    return this.put(`/instances/shipping`, `v1`, request);
  }

  public updateOrderItemInstanceWorkflowStatus(instances: string[], status: string): Observable<void> {
    const request = <IOrderItemInstanceUpdateStatusRequest>{
      instances: instances,
      status: status
    };
    return this.put(`/instances/status`, `v1`, request);
  }
}
